import React, { useState } from "react";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import Footer from "../../layout/common/Footer";
import Header from "../../layout/common/Header";
import NavHeader from "../../layout/common/NavHeader";
import SidebarTest from "../../layout/common/SidebarTest";
import ContentBody from "../../layout/faq/ContentBody";

const FAQList = () => {
  const [pageNumber, setPageNumber] = useState(0);
  const [sortBy, setSortBy] = useState("createDate");
  const [sortType, setSortType] = useState(true);
  const [faqListData, setFAQListData] = useState([]);
  const [perPageRecords, setPerPageRecords] = useState(10);
  const [searchValue, setSearchValue] = useState("");

  const onChangePageNumberHandler = (e) => {
    setPageNumber(e);
  };

  const sortOnClickHandler = (e) => {
    setSortBy(e);
  };

  const sortTypeOnClickHandler = (e) => {
    setSortType(e);
  };

  const pageChange = (val) => {
    setPerPageRecords(val);
  };

  const searchValueChange = (val) => {
    setSearchValue(val);
  };

  let pageCount = 0;
  if (faqListData && faqListData.totalUsers && faqListData.totalUsers > 0) {
    pageCount = Math.ceil(faqListData.totalUsers / perPageRecords);
  }

  useEffect(() => {
    const query = {
      sortby: sortBy,
      sorttype: sortType,
      perpage: perPageRecords,
      currentpage: pageNumber + 1,
      search: searchValue,
    };
    (async () => {
      const data = await fetch(process.env.REACT_APP_API_URL +"faqs-listing", {
        method: "POST",
        body: JSON.stringify(query),
        headers: {
          "Content-type": "application/json",
        },
      });
      const response = await data.json();
      setFAQListData(response.faqs);
    })();
  }, [pageNumber, sortBy, perPageRecords, searchValue, sortType]);
  return (
    <React.Fragment>
      <Helmet>
        <title>Faq's</title>
      </Helmet>
      <NavHeader />
      <Header />
      <SidebarTest />
      <ContentBody
        title="Faq's"
        faqListData={faqListData}
        pageNumber={pageNumber}
        onChangePageNumber={onChangePageNumberHandler}
        usersPerPage={perPageRecords}
        pageCount={pageCount}
        onChangeSortClick={sortOnClickHandler}
        onChangeSortType={sortTypeOnClickHandler}
        onSearchChang={searchValueChange}
        onPerPageChange={pageChange}
      />
      <Footer />
    </React.Fragment>
  );
};

export default FAQList;
